import React from 'react';

interface DependenciaBadgeProps {
  origemNome: string;
  onClick?: () => void;
}

/** Nunca usar "Bloqueada" — o padrão do Maestro é sempre "Aguardando conclusão de dependência" (seção 16). */
const DependenciaBadge: React.FC<DependenciaBadgeProps> = ({ origemNome, onClick }) => (
  <button type='button' className='mc-dep-badge' onClick={onClick} disabled={!onClick}>
    <i className='bi bi-hourglass-split' />
    <span>Aguardando: <strong>{origemNome}</strong></span>
  </button>
);

export default DependenciaBadge;
